import variables from '../variables'

import type { MenuOverrideToken } from './types'

const Menu: MenuOverrideToken = {
  colorGroupTitle: variables.gray60,

  colorItemTextHover: variables.baseBlack,
  colorItemTextSelected: variables.baseBlack,

  colorItemBgHover: variables.brandBlue20,
  colorItemBgActive: variables.brandBlue20,
  colorItemBgSelected: variables.brandBlue20,

  controlHeightLG: variables.controlMiddleSize
} as const

export default Menu
